module.exports = __webpack_public_path__ + "media/images/shark/Shark3-p-500-e6e39a1cdcdca05ec2453c02db0b664f.png";